import { render, staticRenderFns } from "./kpsrRiskTab.vue?vue&type=template&id=28cdfdf0"
import script from "./kpsrRiskTab.vue?vue&type=script&lang=js"
export * from "./kpsrRiskTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28cdfdf0')) {
      api.createRecord('28cdfdf0', component.options)
    } else {
      api.reload('28cdfdf0', component.options)
    }
    module.hot.accept("./kpsrRiskTab.vue?vue&type=template&id=28cdfdf0", function () {
      api.rerender('28cdfdf0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/kpsr/risk/kpsrRiskTab.vue"
export default component.exports